import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { OptionNewItem_EditPage_Query } from "./query";

type Props = {
	hotelID: string;
	optionID: string | undefined;
};

export const useOptionEditQuery = ({ hotelID, optionID }: Props) => {
	const { data } = useCustomSuspenseQuery(OptionNewItem_EditPage_Query, {
		variables: { hotelID, duplicateOptionID: optionID },
		fetchPolicy: "no-cache",
	});

	return data;
};
